// ----------------------------------------------------------------------
// Organization Affiliations Translations - French
// ----------------------------------------------------------------------

export const affiliationsFr = {
  affiliations: {
    sub_organizations: 'Sous-Organisations',
    supra_org: 'Organisation Supra',
    enable_supra_org: 'Activer Organisation Supra',
    enable_supra_org_description:
      'Activez cette option pour faire de votre organisation une organisation faîtière pouvant avoir des sous-organisations affiliées.',
    disable_supra_org_warning:
      'La désactivation supprimera toutes les affiliations existantes. Cette action est irréversible.',
    affiliated_organizations: 'Organisations Affiliées',
    no_affiliations: 'Aucune organisation affiliée pour le moment.',
    no_affiliations_description:
      'Ajoutez des organisations qui font partie de votre structure faîtière.',
    add_organization: 'Ajouter une Organisation',
    search_organizations: 'Rechercher une organisation à affilier...',
    affiliation_type: "Type d'affiliation",
    type_member: 'Membre',
    type_chapter: 'Section',
    type_partner: 'Partenaire',
    status: 'Statut',
    status_active: 'Actif',
    status_pending: 'En attente',
    status_suspended: 'Suspendu',
    joined_at: 'Rejoint le',
    notes: 'Notes',
    notes_placeholder: 'Notes optionnelles sur cette affiliation...',
    actions: 'Actions',
    remove_affiliation: "Supprimer l'affiliation",
    remove_affiliation_confirm:
      "Êtes-vous sûr de vouloir supprimer cette affiliation ? L'organisation restera indépendante et conservera tous ses événements.",
    edit_affiliation: "Modifier l'affiliation",
    share_public_events: 'Partager les événements publics',
    share_public_events_description: "Afficher les événements publics de cette organisation sur la page de l'organisation parente",
    share_statistics: 'Partager les statistiques',
    share_statistics_description: "Partager les statistiques agrégées avec l'organisation parente",
    use_branding: "Utiliser l'image de marque parente",
    use_branding_description: "Afficher l'image de marque de l'organisation parente sur les événements",
    parent_organization: 'Organisation Parente',
    member_of: 'Membre de',
    sharing_preferences: 'Préférences de Partage',
    affiliation_created: 'Organisation affiliée avec succès',
    affiliation_updated: 'Affiliation mise à jour avec succès',
    affiliation_removed: 'Affiliation supprimée avec succès',
    supra_enabled: 'Organisation supra activée',
    supra_disabled: 'Organisation supra désactivée et toutes les affiliations supprimées',
    already_affiliated: "Cette organisation est déjà affiliée à une autre organisation supra",
    cannot_affiliate_self: 'Impossible d\'affilier une organisation à elle-même',
    only_evenementiel: 'Seules les organisations événementielles peuvent être affiliées',
    no_results: 'Aucune organisation trouvée',
    select_org: 'Sélectionner une organisation',
    confirm_disable: 'Confirmer la désactivation',
    cancel: 'Annuler',
    save: 'Enregistrer',
    confirm: 'Confirmer',
    add: 'Ajouter',
  },
};
